<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>C端数据管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户注册信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card style="margin-top: 15px">
      <el-descriptions title="用户信息" border>
        <el-descriptions-item label="手机号">
          {{ userInfo.phone }}
          <el-button type="text" style="margin-left: 10px;" @click="getCodeFn">获取临时验证码</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="用户名">{{
          userInfo.userName
        }}</el-descriptions-item>
        <el-descriptions-item label="性别">
          <template>
            <el-tag type="success" v-if="userInfo.sex === '2'" size="small"
              >男</el-tag
            >
            <el-tag type="danger" v-else-if="userInfo.sex === '1'" size="small"
              >女</el-tag
            >
            <span v-else>-</span>
          </template>
        </el-descriptions-item>
        <el-descriptions-item label="国籍">{{
          userInfo.nationality ? userInfo.nationality : '-'
        }}</el-descriptions-item>
        <el-descriptions-item label="证件类型">
          <template>
            <el-tag type="danger" v-if="userInfo.cardType === '1'" size="mini"
              >身份证</el-tag
            >
            <el-tag
              type="success"
              v-else-if="userInfo.cardType === '2'"
              size="mini"
              >护照</el-tag
            >
            <span v-else>-</span>
          </template></el-descriptions-item
        >
        <el-descriptions-item label="证件号">{{
          userInfo.idCard
        }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{
          userInfo.email
        }}</el-descriptions-item>
        <el-descriptions-item label="学校省市区"
          >{{ userInfo.province }}/{{ userInfo.city }}/{{
            userInfo.area
          }}</el-descriptions-item
        >
        <el-descriptions-item label="学校名">{{
          userInfo.schoolName
        }}</el-descriptions-item>
        <el-descriptions-item label="年级"
          >{{ userInfo.grade }}年级</el-descriptions-item
        >
        <el-descriptions-item label="组别">{{ getLevelLabel(userInfo.level) }}</el-descriptions-item>
        <el-descriptions-item label="赛区">{{ userInfo.districtName }}</el-descriptions-item>
      </el-descriptions>
    </el-card>
    <!-- 地址列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">地址信息</span>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="userInfoAddressList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="收件人姓名" prop="receiptName"></el-table-column>
        <el-table-column label="收件人手机号" prop="receiptPhone"></el-table-column>
        <el-table-column label="省市区" >
          <template slot-scope="scope">
            <span>{{scope.row.province}}-{{scope.row.city}}-{{scope.row.area}}</span>
          </template>
        </el-table-column>
        <el-table-column label="详细地址" prop="receiptAddress"></el-table-column>
        <el-table-column label="默认地址" prop="isDefault">
          <template slot-scope="scope">
            {{ scope.row.isDefault === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 优惠券信息 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">优惠券信息</span>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="couponList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="优惠券" prop="couponName"></el-table-column>
        <el-table-column label="优惠金额" prop="discountAmount" :formatter="priceFormatter1"></el-table-column>
        <el-table-column label="优惠券类型" prop="couponTypeStr">
          <template slot-scope="scope">
            <el-button round :type="scope.row.couponType === 1 ? 'primary' : 'success'" size="mini">{{ scope.row.couponType === 1 ? '满减' : '无门槛' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="最低购买金额" prop="minimumPurchase" :formatter="priceFormatter2"></el-table-column>
        <el-table-column label="有效期" prop="expirationDate"></el-table-column>
        <el-table-column label="使用状态" prop="usedStr">
          <template slot-scope="scope">
            <el-tag :type="scope.row.used === 2 ? 'success' : scope.row.used === 3 ? 'info' : scope.row.used === 4 ? 'danger' : ''" size="mini">
              {{ scope.row.usedStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="使用/撤回/过期日期" prop="usedDate"></el-table-column>
        <el-table-column label="优惠券状态" prop="usedStr">
          <template slot-scope="scope">
            <el-tag :type="scope.row.used === 1 ? 'success' : 'danger'" size="mini">
              {{ scope.row.used === 1 ? '已上架' : '已下架' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 报名信息 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">报名信息</span>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column label="学校" prop="schoolName">
          <template slot-scope="scope">
            <span
              v-if="scope.row.fillschoolName && scope.row.fillschoolName !== ''"
              >{{ scope.row.fillschoolName }}</span
            >
            <span v-else>{{ scope.row.schoolName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="组别"
          prop="enrollmentLevel"
          :formatter="groupFormatter"
        ></el-table-column>
        <el-table-column
          label="年级"
          prop="grade"
          :formatter="gradeFormatter"
        ></el-table-column>
        <el-table-column label="联系方式" prop="phone"></el-table-column>
        <el-table-column
          label="开通产品名称"
          prop="productName"
        ></el-table-column>
        <el-table-column
          label="开通类型"
          prop="openType"
          :formatter="openTypeFormatter"
        ></el-table-column>
        <el-table-column label="参赛方式" prop="isOnline" width="125px">
          <template slot-scope="scope">
            <el-tag
            :type=" scope.row.score ? 'success' : 'danger' "
              v-if="scope.row.isOnline + '' === '1'"
              size="mini"
              >线上参赛({{ scope.row.score ? '已答题' : '未答题' }})</el-tag
            >
            <el-tag type="warning" v-else size="mini">线下参赛</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="开通时间" prop="createTime"></el-table-column>
        <el-table-column label="订单号" prop="orderNo"></el-table-column>
      </el-table>
    </el-card>

    <!-- 订单列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">订单信息</span>
        </el-col>
      </el-row>
      <el-table header-cell-class-name="tableHeaderStyle"
        :data="orderList" stripe
        @expand-change="expandFn">
        <el-table-column type="expand" class="expand-td">
          <template slot-scope="scope">
            <el-table :data="scope.row.productList" header-row-class-name="table-head-row" header-cell-class-name="table-head-cell" cell-class-name="table-head-cell">
              <el-table-column label="赛季" prop="season"></el-table-column>
              <el-table-column label="产品名称" prop="productName" width="300px"></el-table-column>
              <el-table-column label="赛程" prop="raceSchedule" :formatter="raceScheduleFormatter"></el-table-column>
              <el-table-column label="赠送词库到期时间" prop="expiryDate" width="180px" :formatter="expiryDateFormatter"></el-table-column>
              <el-table-column label="数量" prop="productNum" width="100px"></el-table-column>
              <el-table-column label="总价" prop="totalAmount"></el-table-column>
              <el-table-column label="单价" prop="unitPrice"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="订单名称" prop="orderName" width="150px"></el-table-column>
        <el-table-column label="订单号" prop="orderNo"></el-table-column>
        <el-table-column label="订单金额" prop="orderAmount"></el-table-column>
        <el-table-column label="实付金额" prop="paymentAmount"></el-table-column>
        <el-table-column label="订单来源" prop="orderSource" :formatter="sourceFormatter"></el-table-column>
        <el-table-column label="下单时间" prop="orderTime"></el-table-column>
        <el-table-column label="是否寄送" prop="isSend" width="100px">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.isSend + '' === '1'" size="mini">需要寄送</el-tag>
            <el-tag type="warning" v-else size="mini">无需寄送</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" prop="orderStatus" width="100px">
          <template slot-scope="scope">
            <el-tag v-if="findStatus(scope.row.orderStatus)" :type="findStatus(scope.row.orderStatus).type" size="mini">{{ findStatus(scope.row.orderStatus).dictLabel }}</el-tag>
            <!-- <el-tag style="color: #28526c" v-if="scope.row.orderStatus + '' === '1'" size="mini">待支付</el-tag>
            <el-tag type="warning" v-else-if="scope.row.orderStatus + '' === '2'" size="mini">待发货</el-tag>
            <el-tag type="primary" v-else-if="scope.row.orderStatus + '' === '3'" size="mini">已发货</el-tag>
            <el-tag style="color: #498327" v-else-if="scope.row.orderStatus + '' === '4'" size="mini">订单完成</el-tag>
            <el-tag style="color: #fc530a" v-else-if="scope.row.orderStatus + '' === '5'" size="mini">申请退款</el-tag>
            <el-tag style="color: #fcbc07" v-else-if="scope.row.orderStatus + '' === '6'" size="mini" >退款审核中</el-tag>
            <el-tag type="success" v-else-if="scope.row.orderStatus + '' === '7'" size="mini">退款成功</el-tag>
            <el-tag type="danger" v-else-if="scope.row.orderStatus + '' === '8'" size="mini">退款失败</el-tag>
            <el-tag type="info" v-else-if="scope.row.orderStatus + '' === '9'" size="mini">订单关闭</el-tag> -->
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getSysUserInfo, getSysUserAddressListByUserId, queryTbOrderList, queryProductOrderList, queryTbEnrollmentList } from '@/http/api'
export default {
  data () {
    return {
      userInfo: {},
      userInfoAddressList: [],
      userId: this.$route.query.userId,
      orderList: [],
      dataList: [],
      orderStatusList: this.$userInfo.orderStatus(),
      order_source: this.$userInfo.orderSource(),
      dict_group: this.$userInfo.dict_group(),
      dict_grade: this.$userInfo.getGradeData(),
      p_open_type: this.$userInfo.getDataList(this, 'p_open_type').then(value => { this.p_open_type = value }),
      queryForm: {
        phone: '',
        name: '',
        season: this.$chnEngStatusCode.defaultSeason,
        group: '',
        schoolId: '',
        pageNum: 1,
        pageSize: 10000,
        userName: '',
        userId: this.$route.query.userId
      },
      order_status: this.$userInfo.orderStatus(),
      couponList: []
    }
  },
  created () {
    console.log(this.orderStatusList)
    this.getUserInfoData()
    this.getUserInfoAddressList()
    this.queryTbOrderList()
    this.getDataList()
    this.getCouponList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    findStatus (status) {
      return this.order_status.find(item => item.dictCode === status)
    },
    // 优惠券
    getCouponList () {
      const params = { pageNum: 1, pageSize: 40, userId: this.userId, activityType: this.$chnEngStatusCode.activityType, season: this.$chnEngStatusCode.defaultSeason }
      this.$http.get('coupon/queryTbUserCouponPage', { params }).then(res => {
        if (res.code === 200) {
          this.couponList = res.data.list
        }
      })
    },
    // 获取用户信息详情
    getUserInfoData () {
      getSysUserInfo({ userId: this.userId }).then((res) => {
        console.log('getSysUserInfo', res)
        this.userInfo = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 获取用户地址列表
    getUserInfoAddressList () {
      getSysUserAddressListByUserId({ userId: this.userId }).then((res) => {
        console.log('getSysUserAddressListByUserId', res)
        this.userInfoAddressList = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 获取报名列表
    getDataList () {
      queryTbEnrollmentList(this.queryForm).then((res) => {
        this.dataList = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 订单
    queryTbOrderList () {
      queryTbOrderList({ userId: this.userId }).then(res => {
        res.data.forEach(item => {
          item.productList = []
          item.expanded = false
        })
        this.orderList = res.data
      })
    },
    expandFn (row) {
      if (!row.expanded) {
        queryProductOrderList({ orderNo: row.orderNo, userId: this.userId }).then(res => {
          const productList = res.data
          this.orderList.find(item => item.orderNo === row.orderNo).productList = productList
        })
      }
      row.expanded = !row.expanded
    },
    sourceFormatter (data) {
      var temp = '未知'
      for (const key in this.order_source) {
        if (Object.hasOwnProperty.call(this.order_source, key)) {
          const element = this.order_source[key]
          if (element.dictValue === data.orderSource + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    expiryDateFormatter (data) {
      return data.expiryDate || '-'
    },
    raceScheduleFormatter (row) {
      const data = row.raceSchedule
      return data === 1 ? '城市初选' : data === 2 ? '区域决选' : data === 3 ? '-' : data === 4 ? '全球总决选' : '-'
    },
    getLevelLabel (level) {
      return level ? this.dict_group.find(item => item.dictCode === level).dictLabel : '-'
    },
    groupFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_group) {
        if (Object.hasOwnProperty.call(this.dict_group, key)) {
          const element = this.dict_group[key]
          if (element.dictValue === data.enrollmentLevel + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    gradeFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_grade) {
        if (Object.hasOwnProperty.call(this.dict_grade, key)) {
          const element = this.dict_grade[key]
          if (element.dictValue === data.grade + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    openTypeFormatter (data) {
      var temp = '未知'
      for (const key in this.p_open_type) {
        if (Object.hasOwnProperty.call(this.p_open_type, key)) {
          const element = this.p_open_type[key]
          if (element.dictValue === data.openType + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    getCodeFn () {
      this.$http.post('/common/smsVerificationTemporaryCode', { codeType: 6, phone: this.userInfo.phone }).then(res => {
        if (res.code === 200) {
          this.$confirm('', `验证码：${res.data}`, {
            confirmButtonText: '确定',
            cancelButtonText: null,
            type: ''
          }).then(() => {
          })
        }
      })
    },
    priceFormatter1 (data) {
      return `¥${data.discountAmount}`
    },
    priceFormatter2 (data) {
      return data.minimumPurchase ? `¥${data.minimumPurchase}` : '--'
    }
  }
}
</script>

<style scoped>
::v-deep .el-table__expanded-cell .table-head-row{
  color: #606266;
}
::v-deep .el-table__expanded-cell .table-head-cell{
  background-color: #f5f7fa !important;
  /* border-bottom-color: #dedede !important; */
}
::v-deep .el-table__expanded-cell{
  padding: 0 !important;
}
::v-deep .el-table__expanded-cell .el-table {
  margin-top: 0;
}
::v-deep .el-descriptions-item__label.is-bordered-label {
  background-color: #F0F8FF !important;
  color: #606266 !important;
  font-size: 12px !important;
  font-weight: bold;
  width: 140px;
}
::v-deep .el-descriptions__title{
  font-weight: normal;
  display: flex;
  align-items: center;
}
::v-deep .el-descriptions__title::before{
  display: block;
  content: '';
  width: 3px;
  height: 18px;
  border-radius: 3px;
  background-color: #409EFF;
  margin-right: 6px;
}
</style>
